import React from "react";
import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ children }) => {
  const userName = sessionStorage.getItem("userName");
  const dbKey = sessionStorage.getItem("databaseKey");

  if (!dbKey) {
    return <Navigate to="/" replace />;
  }

  if (!userName) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default ProtectedRoute;
